import baseContainer from './_baseContainer';
import ActivityLogs from '../components/view/ActivityLogs/ActivityLogs';

const mapStateToProps = (state) => {
  return {
    token: state?.auth?.authentication || undefined,
  };
};

const mapDispatchToProps = () => ({
});

export default baseContainer(mapStateToProps, mapDispatchToProps)(ActivityLogs);
